import {useMemo} from 'react';
import subscriptionUtils from '../../utils/subscriptionUtils';
import _get from 'lodash/get';
import useSolutionType from './useSolutionType';

const useSkincare = auth => {
  const {isSkinAnalysisPremium, enterpriseSettings} = useSolutionType(auth);

  const version = subscriptionUtils.getSkincareVersion(auth);
  const isEnterprise = subscriptionUtils.isEnterprise(auth);
  const isVersionAbove2AndHd =
    version >= 2 &&
    _get(auth, 'brandInfo.recommendationAbility', 'SD') === 'HD';

  return useMemo(
    () => ({
      isEnterprise,
      isV1: version === 1, // no CRM
      isV2Above: version >= 2, // CRM + SD or HD
      isVersionAbove2AndHd, // CRM + HD
      isSupportSubOptions:
        version >= 2 && (isSkinAnalysisPremium || isEnterprise),
      isSupportSkinType:
        isVersionAbove2AndHd &&
        (isSkinAnalysisPremium ||
          enterpriseSettings.includes('enableSkinType')),
      isSupportSensitivity:
        isVersionAbove2AndHd &&
        (isSkinAnalysisPremium ||
          enterpriseSettings.includes('enableSensitivity')),
    }),
    [auth, isSkinAnalysisPremium, version, isEnterprise]
  );
};

export default useSkincare;
